<template>
    <div class="page">
        <div class="header">
            <Header :current="['fw']"></Header>
            <div class="header-search">
<!--                <a-input-search-->
<!--                    placeholder="输入搜索内容"-->
<!--                    @search="onSearch"-->
<!--                />-->
                <a-input-group compact>
                    <a-select v-model:value="selectValue">
                        <a-select-option value="service">服务</a-select-option>
                        <a-select-option value="demand">需求</a-select-option>
                    </a-select>
                    <a-input-search
                        placeholder="输入搜索内容"
                        @search="onSearch"
                        style="width: calc(100% - 100px)"
                    />
                </a-input-group>
            </div>
        </div>
        <div class="content">
            <div class="policy-container">
                <div class="policy-container-title">
                    <p>供需服务</p>
                    <p>Supply Service</p>
                </div>
                <div class="service-add">
                    <a-space>
                        <a-button @click="addService">发布服务</a-button>
                        <a-button @click="addDemand">发布需求</a-button>
                    </a-space>
                </div>
                <div class="home-nf">
                    <serviceCard :params="{more: true, size: 6}" ref="serviceCardRef"></serviceCard>
                    <demandCard :params="{more: true, size: 6}" ref="demandCardRef"></demandCard>
                </div>

<!--                <div class="policy-container-title">-->
<!--                    <p>生产服务</p>-->
<!--                    <p>Production Service</p>-->
<!--                </div>-->
<!--                <div class="service-add">-->
<!--                    <a-space>-->
<!--                        <a-button @click="addTG">发布托管</a-button>-->
<!--                        <a-button @click="addDD">发布订单</a-button>-->
<!--                    </a-space>-->
<!--                </div>-->
<!--                <div class="home-nf">-->
<!--                    <tgCard :params="{more: true, size: 6}"></tgCard>-->
<!--                    <ddCard :params="{more: true, size: 6}"></ddCard>-->
<!--                </div>-->
                <div class="policy-container-title">
                    <p>金融保险</p>
                    <p>Financial Services</p>
                </div>
                <div class="service-card">
                    <div class="service-card-div">
                        <p class="service-card-title">农业保险</p>
                        <div v-for="(item, i) in xdList" :key="i" class="service-card-list">
                            <router-link :to="'/portal/articles?title='+'农业保险&id='+item.id" target="_blank">
                                <p>{{ item.title }}</p>
                            </router-link>
                        </div>
                        <div class="fs-btn">
                            <router-link :to="'/portal/Insurance'" target="_blank">
                                <a-button>我要投保</a-button>
                            </router-link>
                        </div>
                    </div>
                    <div class="service-card-div service-card-div-thin">
                        <p class="service-card-title">信贷服务</p>
                        <div v-for="(item, i) in rtData.list0" :key="i" class="service-card-list">
                            <router-link :to="'/portal/articles?title='+'信贷服务&secId='+item.secondCategoryId+'&id='+item.id" target="_blank">
                                <p>{{ item.title }}</p>
                            </router-link>
                        </div>
<!--                        <a-collapse v-model:activeKey="activeKey" accordion style="margin-top: 20px">-->
<!--                            <a-collapse-panel v-for="item in rtData.list0" :key="item.secondCategoryId+'&'+item.id" :header="item.title">-->
<!--                                <p v-html="rtData.text"></p>-->
<!--                            </a-collapse-panel>-->
<!--                        </a-collapse>-->
                        <div class="fs-btn">
                            <router-link :to="'/portal/Loan'" target="_blank">
                                <a-button>我要贷款</a-button>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Footer></Footer>
    </div>
</template>

<script>
import Header from '@/components/portal/Header'
import Footer from "../../components/portal/Footer"
import serviceCard from "@/views/portal/components/serviceCard"
import demandCard from "@/views/portal/components/demandCard"
// import tgCard from "@/views/portal/components/tgCard"
// import ddCard from "@/views/portal/components/ddCard"
import {getProcessDetail, getProcessList, getDemandProcessList} from "@/api/policy"
import {ref} from 'vue'
import {reactive} from "@vue/runtime-dom"
import router from "@/router"
export default {
    name: "Service",
    setup() {
        const xdList = ref([])
        const activeKey = ref(['1'])
        const rtData = reactive({
            list0: [],
            title: ''
        })
        const selectValue = ref('service')
        return {
            xdList,
            activeKey,
            rtData,
            selectValue
        }
    },
    watch: {
        activeKey(val) {
            if (val) {
                this.getText(val)
            }
        }
    },
    mounted() {
        this.initData()
        this.initCard()
    },
    methods: {
        onSearch(value) {
            if (this.selectValue === 'service') {
                this.$refs.serviceCardRef.inputValue = value
                this.$refs.serviceCardRef.getServiceData(1)
            } else if (this.selectValue === 'demand') {
                this.$refs.demandCardRef.inputValue = value
                this.$refs.demandCardRef.getDemandData(1)
            }
        },
        async initData() {
            // const params = {"current": 1,"model": {"secondCategoryId": 300012}, "size": 10}
            getDemandProcessList(300012).then(res => {
                const list = res.map(k => ({
                    id: k.id,
                    date: k.createTime,
                    title: k.title,
                }))
                this.xdList = list
            })
        },
        async initCard() {
            // const params1 = {"current": 1,"model": {"secondCategoryId": 300011}, "size": 102}
            const data0 = await getDemandProcessList(300011)
            // const data1 = await getDemandProcessList(params1)
            for (const i in data0) {
                data0[i].secondCategoryId = 300111
            }
            // for (const i in data1.records) {
            //     data1.records[i].secondCategoryId = 300112
            // }
            // this.rtData.list0 = [...data0.records,...data1.records]
            this.rtData.list0 = data0

        },
        async getText(id) {
            const data = await getProcessDetail(id)
            console.log(data)
            this.rtData.text = data.text
            // navClick('业务流程')

        },
        addService() {
            router.push({ name: '/portal/ServiceInformationAdd'})
        },
        addDemand() {
            router.push({ name: '/portal/DemandInformationAdd'})
        },
        addTG() {
            router.push({ name: '/portal/TGAdd'})
        },
        addDD() {
            router.push({ name: '/portal/DDAdd'})
        }
    },
    components: {
        Header,
        Footer,
        serviceCard,
        demandCard,
        // tgCard,
        // ddCard
    }
}
</script>

<style scoped lang="stylus">
    .page {
        width 100%
        height 100%
        position relative
        font-size 16px
        background-color #FFF
        /deep/ .ant-btn {
            transition .2s
        }
        /deep/ .ant-btn:hover {
            transform scale(1.02)
            box-shadow 0 3px 6px rgba(22, 122, 218, 0.26)
        }
        .header {
            width 100%
            height 730px
            padding-top 130px
            box-shadow 0 23px 120px rgba(0, 0, 0, 0.3)
            border-bottom-left-radius 315px
            border-bottom-right-radius 315px
            background-image url("../../assets/img/portal_service_bg.png")
            background-size 100% 100%
            background-repeat no-repeat
            .header-search {
                width 600px
                height 70px
                margin 200px auto
                /deep/ .ant-select-selector {
                    height 70px
                    line-height 70px
                    border 1px solid #44a73e
                    border-top-left-radius 10px
                    border-bottom-left-radius 10px
                }
                /deep/ .ant-select-selection-item {
                    height 70px
                    line-height 70px
                    font-size 18px
                }
            }
            .header-search >>> .ant-input-affix-wrapper {
                height 70px
                font-size 22px
            }
            .header-search >>> .ant-input-affix-wrapper > input.ant-input {
                border-radius 5.333vw
                font-size 18px
                padding 4px 20px
            }
            .header-search >>> .ant-input-affix-wrapper .ant-input-suffix {
                margin-right 10px
            }
        }
        .content {
            width 100%
            min-height 200px
            padding 70px 0
            .policy-container {
                width 100%
                margin-bottom 70px
                .policy-container-title {
                    width 100%
                    background-image url("../../assets/img/portal_policy_title_bg.png")
                    background-repeat no-repeat
                    background-position-x center
                    background-position-y center
                    text-align center
                    margin-bottom 75px
                }
                .policy-container-title p:first-child {
                    font-size 46px
                    color #000
                    font-weight bold
                }
                .policy-container-title p:last-child {
                    font-size 35px
                    color #CECECE
                }
                .service-add {
                    width 100%
                    text-align center
                    margin-bottom 45px
                }
                .service-add .ant-btn {
                    width 315px
                    height 66px
                    line-height 60px
                    font-size 36px
                    color #FFF
                    border-radius 40px
                    background-color #167ADA
                }

                .home-nf {
                    width 100%
                    display flex
                    flex-wrap wrap
                    justify-content space-evenly
                    margin-bottom 45px
                    .home-nf-title {
                        width 100%
                        text-align center
                        margin-bottom 35px
                    }
                    .home-nf-title p:first-child {
                        font-size 46px
                        color #000
                        font-weight bold
                    }
                    .home-nf-title p:last-child {
                        font-size 35px
                        color #CECECE
                    }
                }
                .service-card {
                    width 100%
                    min-height 470px
                    max-width 1700px
                    margin 0 auto
                    background rgba(82, 135, 185, 0.08)
                    box-shadow 0 3px 35px rgba(0, 0, 0, 0.16)
                    border-radius 16px
                    display flex
                    flex-wrap wrap
                    .service-card-div {
                        width 50%
                        height 100%
                        padding 50px 90px 50px 180px
                        overflow-y auto
                        position relative
                        .fs-btn {
                            text-align center
                            margin 10px 0
                            position absolute
                            right 90px
                            top 50px
                            /deep/ .ant-btn {
                                font-size 18px
                                color #fff
                                border-radius 10px
                                background-color #167ada
                                padding 0 20px
                                height 40px
                                line-height 40px
                            }
                        }
                        .service-card-title {
                            font-size 34px
                            font-weight bold
                            color #167ADA
                            margin-bottom 45px
                        }
                        .service-card-list {
                            width 100%
                            font-size 24px
                            position relative
                            padding-left 30px
                            margin-bottom 20px
                            border-bottom 1px dotted #707070
                            cursor pointer
                        }
                        .service-card-list a {
                            color #000
                            width 100%
                            display flex
                        }
                        .service-card-list::before {
                            content ''
                            width 17px
                            height 17px
                            position absolute
                            top 12px
                            left 0
                            background-color #167ADA
                            border-radius 50%
                        }
                        .service-card-list p {
                            transition .1s
                            width 100%
                            overflow hidden
                            text-overflow ellipsis
                            white-space nowrap
                        }
                        .service-card-list p:hover {
                            color #167ADA
                        }
                        //.service-card-list p:first-child {
                        //    width 65%
                        //    overflow hidden
                        //    text-overflow ellipsis
                        //    white-space nowrap
                        //}
                        //.service-card-list p:last-child {
                        //    width 30%
                        //    overflow hidden
                        //    text-overflow ellipsis
                        //    white-space nowrap
                        //    text-align right
                        //}
                    }
                    .service-card-div-thin {
                        padding 50px 90px 50px 90px
                    }
                    @media (max-width: 1600px) {
                        .service-card-div {
                            padding 25px 45px 25px 90px
                        }
                        .service-card-div-thin {
                            padding 25px
                        }
                    }
                }
                @media (min-width: 1921px) {
                    .service-card {
                        max-width calc(100% - 250px)
                    }
                }
            }
        }
    }
</style>